import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Chip,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Snackbar,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const RequestCourseList = () => {
    let navigate = useNavigate();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });
    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();

    const [golfPlace, setGolfPlace] = useState([]); //골프장
    const [requestCourse, setRequestCourse] = useState([]); //골프장



    useEffect(() => {
        console.log("RequestCourseList useEffect call")
        actions.extendTime(userData);
        getGolfPlace();
        getRequestCourse();
    }, [userData]);

    

    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }



    const getGolfPlace = async () => {
        console.log('enroll course  getGolfPlace start')
        try {
            let response = await axios.get("/api/booking/GetCourse");
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                console.log("getGolfPlace :" + JSON.stringify(courseData))
                setGolfPlace(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }


    const getRequestCourse = async () => {
        try {
            const reqData = {};

            let response = await axios.post("/api/booking/GetRequestCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                console.log("getRequestCourse :" + JSON.stringify(courseData))
                setRequestCourse(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }

    const findExistCourse = (courseName) => {
        var i = 0;
        for (i = 0; i < golfPlace.length; i++) {
            var existName = golfPlace[i].courseName;
            if (existName.indexOf(courseName) > -1) {
                return golfPlace[i];
            }
        }
        return undefined;
    }


    const completeNewCourse = async (reqCourse) => {


        try {
            const reqData = {};

            if (!reqCourse.serial || !reqCourse.courseName) {
                showSnackBar("코스를 지정하지 않았습니다");
                return;
            }

            reqData.myCourseNum = reqCourse.num;
            reqData.serial = reqCourse.serial;
            reqData.courseName = reqCourse.courseName;


            let response = await axios.post("/api/booking/CompleteNewCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                await getRequestCourse();
            } else {
                showSnackBar('골프장 추가 실패하였습니다');
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 추가에 실패하였습니다');

        }

    }



    const renderRequestCourse = (course) => {

        console.log("renderRequestCourse :" + JSON.stringify(course))
        
        if (!course ) {
            return null;
        }

        let bgAvatarColor = 'success.main';
        let avatarSize = isMobile ? 24 : 56;
        let btnSize = isMobile ? 'small' : 'midium';
        if (course.needMakeNew  == 1) {
            bgAvatarColor = 'warning.main';
        }



//        let makedCourse = findExistCourse(course.inputCourseName)

        const handleSelectCourse = (event) => {
            console.log("course select :" + JSON.stringify(event.target.value))
            let newCourse = event.target.value;
            setRequestCourse(requestCourse.map(reqCourse => {
                
                if (reqCourse.num === course.num) {
                    // Create a *new* object with changes
                    return { ...reqCourse, serial: newCourse.serial, courseName: newCourse.courseName };
                } else {
                    // No changes
                    return reqCourse;
                }
                
//                return reqCourse;

            
            }))
        }


        return (
            <ListItem key={course.num}
                sx={{
                    marginBottom: 3,
                    padding: 0,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                        boxShadow: 3, // Applies an elevation level of 3
                        //                        border: '2px dashed black'
                        padding: { xs: 2, sm: 2, md: 2 },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            // Add other flexbox properties as needed, e.g., justifyContent, alignItems
                            justifyContent: "space-between"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: isMobile ? '5px' : '16px', // Example for spacing between items
                                alignItems: "center",
                            }}
                        >
                            <Avatar sx={{ bgcolor: bgAvatarColor, width: avatarSize, height: avatarSize }} aria-label="recipe">
                                G
                            </Avatar>
                            <Typography
                                variant={isMobile ? 'subtitle1' : 'h6'}
                                sx={{
                                    display: 'flex',
                                }}                    >
                                { course.inputCourseName}
                            </Typography>

                        </Box>
                        <Stack
                            spacing={1}
                            direction="row"
                            sx={{
                                justifyContent: "flex-end",
                                alignItems: "center",
                            }}

                        >
                            <FormControl>
                                <InputLabel>골프장선택</InputLabel>
                                <Select
                                    sx={{ m: 1, minWidth: 120 }}
                                    label="골프장선택"
                                    onChange={(event) => handleSelectCourse(event)}
                                >
                                    {golfPlace.map((gCourse) => (
                                        <MenuItem
                                            key={gCourse.serial}
                                            value={gCourse}
                                        >
                                            {gCourse.courseName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {course.serial ? <Button size={btnSize} variant="outlined" onClick={() => completeNewCourse(course)}>개발완료</Button> : null}
                        </Stack>
                    </Box>
                    <Stack
                        direction="column"
                        sx={{
                            marginTop:2,
                            justifyContent: "center",
                            alignItems: "center",
                        }}

                    >   
   
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'}>신청인 : {course.userEmail} </Typography> 
                        {course.courseName ? <Typography variant={isMobile ? 'body2' : 'subtitle1'}>생성된 코스이름 : {course.courseName} </Typography> : null}
                        {course.serial ? <Typography variant={isMobile ? 'body2' : 'subtitle1'}>생성된 시리얼 : {course.serial} </Typography> : null}
                    </Stack>

                </Box>
            </ListItem>

            
            
        )
    }
    

    return (
        <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Button variant="contained" onClick={() => navigate(-1)}
                >
                    돌아가기
                </Button>


                <List sx={{ width: '100%', bgcolor: 'background.paper', marginTop : 5 ,}}>
                    {requestCourse.map((course) => renderRequestCourse(course))}
                </List>
                
            </Paper>

            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>
        
    )
}
export default RequestCourseList;